export const eventName = {
  viewContent: "View Content",
  completeRegistration: "Complete Registration",
  initiateCheckout: "Initiate checkout",
  addToCart: "Add to Cart",
  startTrial: "Start Trial",
  purchase: "Purchase",
  addPaymentInfo: "Add Payment Info"
};

export const eventNameDataLayer = {
  signUp: "sign_up",
  // GROWTH-8103: { listing_type: "profile" | "organization" | "event" | "job", directory?, profession?, listing_create_page }
  // (helpers/listingCreatedParams.js), not sent for a reused empty draft. The GTM listing_created tag has to map each
  // param before GA sees it (GROWTH-8099). Of GA's event-scoped custom dimensions, listing_upgrade and lead_sale fill
  // directory, profession, heritage, specialty, country, state and city; listing_upgrade fills listing_status;
  // listing_created alone fills listing_create_page.
  listingCreated: "listing_created",
  listingUpgrade: "listing_upgrade",
  leadSale: "lead_sale",
  feedCardClick: "feed_card_click",
  // My Feed type filter click (GROWTH-7573): { type, placement: "sidebar" | "chips" }
  feedFilterType: "feed_filter_type",
  // Header search v2 (GROWTH-7577)
  headerSearchOpen: "header_search_open",
  headerSearchQuery: "header_search_query",
  headerSearchSelect: "header_search_select",
  headerSearchApply: "header_search_apply",
  // Account Settings v2 Save bar (GROWTH-7580): { fields_changed: string[] } on save; no parameters on discard
  accountSettingsSave: "account_settings_save",
  accountSettingsDiscard: "account_settings_discard",
  // Account Settings v2 per-card autosave (GROWTH-7712): { card, fields_changed: string[] } on a save; { card } on a failure
  accountSettingsAutosave: "account_settings_autosave",
  accountSettingsAutosaveError: "account_settings_autosave_error",
  accountSettingsSectionNavClick: "account_settings_section_nav_click",
  // Notifications v2 sticky section links (GROWTH-7719): { section }
  notificationsSectionNavClick: "notifications_section_nav_click",
  // Payments v2 sticky section links (GROWTH-7720): { section }
  paymentsSectionNavClick: "payments_section_nav_click",
  // Team sticky section links (GROWTH-7722): { section }
  teamSectionNavClick: "team_section_nav_click",
  // Listing Editor v2 flag state (GROWTH-7796): { listing_type, variant: "v1" | "v2", in_cohort } once per editor open
  listingEditorVariant: "listing_editor_variant",
  // Listing Editor v2 shell (GROWTH-7795): { type, page } when a page shows; { type, target: "page:<key>" | "block:<key>" } on a nav click
  listingEditorPageView: "listing_editor_page_view",
  listingEditorNavClick: "listing_editor_nav_click",
  // Payments v2 failed-payment banner (GROWTH-7667): { failing_count } when it shows; { invoice_id } on its button
  paymentsFailedBannerShown: "payments_failed_banner_shown",
  paymentsFailedBannerCta: "payments_failed_banner_cta",
  // Team pending-invite banner (GROWTH-7703): { team_member_id } when it shows and on Review
  teamsInviteBannerShown: "teams_invite_banner_shown",
  teamsInviteBannerReview: "teams_invite_banner_review"
};

// The events GTM-MNMRT6F (version 3) sends to GA4 with a tag of its own. helpers/track.js sends every other
// eventNameDataLayer event with gtag. A gtag call for one of these would also fire its GTM tag and count it twice
// (measured, GROWTH-8099), so a name joins this list only together with a GTM tag and leaves it only once that tag is
// gone. How to add an event: dashboard/docs/13-ga4-events.md.
export const gtmForwardedEvents = [
  eventNameDataLayer.signUp,
  eventNameDataLayer.listingCreated,
  eventNameDataLayer.listingUpgrade,
  eventNameDataLayer.leadSale
];

// The id public/index.html initialises. helpers/track.js sends it again with the member's identity (Advanced Matching),
// which attaches to that same pixel; any other id would start a second one. helpers/track.test.js [track-008] fails if
// the two drift apart.
export const fbPixelId = "1148469942527988";
